/****   http.js   ****/
// 导入封装好的axios实例
import { patch } from 'semver'
import request from './request'
 
const http ={
    /**
     * methods: 请求
     * @param url 请求地址 
     * @param params 请求参数
     */
    get(url,params){
        const config = {
            method: 'get',
            url:url
        }
        if(params) config.params = params
        return request(config)
    },
    post(url,params){
        const config = {
            method: 'post',
            url:url
        }
        if(params) config.data = params
        return request(config)
    },
    put(url,params){
        const config = {
            method: 'put',
            url:url + (params.id?params.id:'')
        }
        if(params) config.data = params
        return request(config)
    },
    delete(url, id){
        const config = {
            method: 'delete',
            url:url+id.toString()
        }
        return request(config)
    },
    deleteByData(url, params){
        const config = {
            method: 'delete',
            url:url,
            data:params
        }
        return request(config)
    },
    patch(url,params){
        const config = {
            method: 'patch',
            url:url + (params.id?params.id:''),
            data:params
        }
        return request(config)
    }
}
//导出
export default http


// WEBPACK FOOTER //
// ./src/utils/http.js